

















import { Component, Vue } from "vue-property-decorator";
import imgDetailCom from "./imgDetailCom.vue";
import { commodityDetail } from "@/req/shopManage";

@Component({
  components: { imgDetailCom },
})
export default class Home extends Vue {
  public modal = false;
  public detail: any = [];
  public limit = 0;
  public show(row, commodityId) {
    this.getListDetail(commodityId); // 上架前的详情
    const $imgDetailCom2: any = this.$refs.imgDetailCom2; // 拒绝收款时的详情
    $imgDetailCom2.show(row);
    this.modal = true;
  }

  public async getListDetail(rowId) {
    const res = await commodityDetail({
      token: this.$fn.cookies.getToken("token"),
      commodity_id: rowId,
    });
    if (res.code == 0) {
      this.detail = res.data;
      const $imgDetailCom: any = this.$refs.imgDetailCom;
      $imgDetailCom.show(this.detail);
    }
  }
}
